const Microphone2Icon = () => (
  <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.0002 18.5833C16.5785 18.5833 18.6668 16.495 18.6668 13.9167V7.50001C18.6668 4.92168 16.5785 2.83334 14.0002 2.83334C11.4218 2.83334 9.3335 4.92168 9.3335 7.50001V13.9167C9.3335 16.495 11.4218 18.5833 14.0002 18.5833Z"
      stroke="#00A389"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.0752 11.7583V13.7417C5.0752 18.665 9.07686 22.6667 14.0002 22.6667C18.9235 22.6667 22.9252 18.665 22.9252 13.7417V11.7583"
      stroke="#00A389"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.3784 8.00167C13.4284 7.61667 14.5718 7.61667 15.6218 8.00167"
      stroke="#00A389"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0669 10.475C13.6852 10.3117 14.3269 10.3117 14.9452 10.475"
      stroke="#00A389"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M14 22.6667V26.1667" stroke="#00A389" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Microphone2Icon;
